/**
 * Переключение темы
 * # ⛓️ CURSOR_ANCHOR:ui:theme-toggle
 */

(function() {
  'use strict';

  var THEME_LIGHT = window.THEME_CONSTANTS.LIGHT;
  var THEME_DARK = window.THEME_CONSTANTS.DARK;
  var THEME_AUTO = window.THEME_CONSTANTS.AUTO;

  // Флаг для предотвращения двойного срабатывания
  var isToggling = false;
  var lastToggleTime = 0;

  /**
   * Переключить тему
   */
  function toggleTheme() {
    var now = Date.now();
    
    // Защита от двойного срабатывания (debounce)
    if (isToggling || (now - lastToggleTime < 300)) {
      return;
    }
    
    isToggling = true;
    lastToggleTime = now;
    
    try {
      var current = window.THEME_STORAGE.get();
      var next;
      
      // Цикл переключения: light -> dark -> auto -> light
      if (current === THEME_LIGHT) {
        next = THEME_DARK;
      } else if (current === THEME_DARK) {
        next = THEME_AUTO;
      } else {
        next = THEME_LIGHT;
      }
      
      window.THEME_STORAGE.set(next);
      window.THEME_APPLICATION.apply(next);
      window.THEME_UI.updateToggleButton(next);
      
    } catch (e) {
      console.error('Error toggling theme:', e);
    } finally {
      // Снимаем блокировку через небольшую задержку
      setTimeout(function() {
        isToggling = false;
      }, 300);
    }
  }

  /**
   * Установить конкретную тему
   */
  function setTheme(theme) {
    if (![THEME_LIGHT, THEME_DARK, THEME_AUTO].includes(theme)) {
      return;
    }
    
    window.THEME_STORAGE.set(theme);
    window.THEME_APPLICATION.apply(theme);
    window.THEME_UI.updateToggleButton(theme);
  }

  window.THEME_TOGGLE = {
    toggle: toggleTheme,
    set: setTheme
  };
})();

